import { format, isValid } from 'date-fns';

const dateToMonthYear = (date = new Date()) =>
  date && isValid(date) ? format(date, 'MMM yyyy') : 'Invalid Date';

export default dateToMonthYear;
